import { useAppTheme } from '@shared-ui/theme'
import Svg, { Path } from 'react-native-svg'

type Props = {
  size?: number
  color?: string
}

// Обновление курса из макета: одиночная стрелка по кругу.
// Глиф шрифта под тем же именем рисует две стрелки — дизайну не соответствует
export function AppIconRefresh({ size = 24, color }: Props) {
  const theme = useAppTheme()
  const fill = color ?? theme.COLOR_ICON_BRAND

  // Отрицательный старт viewBox — те же поля вокруг вектора, что в макете (20×20 при 14.78)
  return (
    <Svg width={size} height={size} viewBox="-2.61 -2.6 20 20" fill="none">
      <Path
        fill={fill}
        d="M13.1139 7.39096C13.1137 4.22955 10.5506 1.66715 7.38915 1.66715C5.39176 1.66726 3.63294 2.69053 2.60831 4.24381H3.91924C4.37931 4.24381 4.75265 4.61645 4.75282 5.07648C4.75282 5.53665 4.37941 5.91006 3.91924 5.91006H0.833574C0.373403 5.91006 0 5.53665 0 5.07648V1.99081C0 1.53064 0.373403 1.15724 0.833574 1.15724C1.29374 1.15724 1.66715 1.53064 1.66715 1.99081V2.71409C3.02184 1.05861 5.08133 0.000102383 7.38915 0C11.471 0 14.7799 3.30922 14.7801 7.39096C14.7801 11.4707 11.4685 14.7999 7.38463 14.8C4.1465 14.8 1.7086 12.7415 0.622016 10.3772C0.429869 9.95904 0.613436 9.46362 1.03157 9.27147C1.44965 9.07953 1.94427 9.26298 2.13637 9.68103C3.00018 11.5607 4.90732 13.1338 7.38463 13.1338C10.544 13.1336 13.1139 10.5545 13.1139 7.39096Z"
      />
    </Svg>
  )
}
